export default "__VITE_PUBLIC_ASSET__fe536bc8__"